import {Button} from "react-bootstrap";
import {Modal} from "react-bootstrap";
import parse from "html-react-parser";

interface Props {
  title: string;
  message: string;
  handleClose: () => void;
  show: boolean;
}

export default function MessageModal({ title, message, handleClose, show }: Props) {
  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title className="w-100 text-center">
          <div className="logoModal">
            Constellation
            <div className="second text-end">training</div>
          </div>
          <div className="modal-subtitle mt-2">{title}</div>
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>{parse(message)}</Modal.Body>

      <Modal.Footer className="border-0 justify-content-center">
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
